import mapValuesToRequestPriceForm from './mappers/mapValuesToRequestPriceForm'
import { handleResponse } from './fetchPrices'

export default function(api: GlobalFetch) {
  return async function(values, objectId, calendarId) {
    const requestBody = mapValuesToRequestPriceForm(
      values,
      objectId,
      calendarId,
    )
    const response = await api.fetch(
      `/api/v2/price/index/id_calendar/${calendarId}/id_object/${objectId}`,
      {
        body: JSON.stringify(requestBody),
        method: 'POST',
      },
    )

    if (response.ok) {
      return await handleResponse(response)
    } else {
      throw new Error(response.status.toString())
    }
  }
}
